import { Component, Input } from '@angular/core';

@Component({
    selector: 'aria-linear-progress-bar',
    template: `
    <div *ngIf="sections" class="progress aria-progress">
        <div *ngFor="let section of sections" [class]="'progress-bar ' + section.class" role="progressbar" 
        [ngStyle]="{'width': section.percentage + '%'}"></div>
    </div>
    `,
    styleUrls: ['./linear-progress-bar.component.scss']
})
export class LinearProgressBarComponent {

    @Input() sections: [{
        class: 'primary',
        percentage: number
    }]

    constructor() { }

}
